import { lazy, Suspense } from "react";
import { SEO } from "@/components/SEO";
import { PageDataContext } from "@/lib/pageData";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SettingsProvider, Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import CategoryPage from "@/pages/CategoryPage";
import ServicePage from "@/pages/ServicePage";
import MadhyaPradesh from "@/pages/MadhyaPradesh";
import ServiceAreas from "@/pages/ServiceAreas";
import Contact from "@/pages/Contact";
import { PrivacyPolicy, Terms } from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
const AdminLogin = lazy(() => import("@/pages/admin/AdminLogin"));
const AdminSetup = lazy(() => import("@/pages/admin/AdminSetup"));
const AdminDashboard = lazy(() => import("@/pages/admin/AdminDashboard"));

function AdminLoading() {
  return <><SEO title="Admin | Mynavodayans" description="Private administration area." noindex /><p className="container-x py-20">Loading…</p></>;
}

export function AppRoutes() {
  return (<>
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/services" element={<Layout><Services /></Layout>} />
          <Route path="/services/category/:slug" element={<Layout><CategoryPage /></Layout>} />
          <Route path="/services/:slug" element={<Layout><ServicePage /></Layout>} />
          <Route path="/madhya-pradesh" element={<Layout><MadhyaPradesh /></Layout>} />
          <Route path="/service-areas" element={<Layout><ServiceAreas /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          <Route path="/privacy-policy" element={<Layout><PrivacyPolicy /></Layout>} />
          <Route path="/terms" element={<Layout><Terms /></Layout>} />
          <Route path="/admin" element={<Suspense fallback={<AdminLoading />}><AdminDashboard /></Suspense>} />
          <Route path="/admin/login" element={<Suspense fallback={<AdminLoading />}><AdminLogin /></Suspense>} />
          <Route path="/manage/bootstrap-mynavo" element={<Suspense fallback={<AdminLoading />}><AdminSetup /></Suspense>} />
          <Route path="*" element={<Layout><NotFound /></Layout>} />
        </Routes>
        <Toaster position="top-center" richColors />
  </>);
}

function App({ initialData }) {
  return (
    <BrowserRouter>
      <PageDataContext.Provider value={initialData}>
        <SettingsProvider><AppRoutes /></SettingsProvider>
      </PageDataContext.Provider>
    </BrowserRouter>
  );
}

export default App;
